/**
 * A skeleton loading state for the ShipmentTable component.
 * Provides a visual placeholder while shipment data is being loaded.
 */
import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

const DEFAULT_COLUMNS = 7; // Match the number of columns in ShipmentTable
const DEFAULT_ROWS = 10;

/**
 * Props for the ShipmentTableSkeleton component.
 */
interface Props {
  /**
   * Number of columns to display in the skeleton.
   * @default 7
   */
  columns?: number;

  /**
   * Number of rows to display in the skeleton.
   * @default 10
   */
  rows?: number;
}

/**
 * A skeleton loading state for the ShipmentTable component.
 * Matches the structure and layout of the actual table.
 */
export function ShipmentTableSkeleton({
  columns = DEFAULT_COLUMNS,
  rows = DEFAULT_ROWS,
}: Props) {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            {Array.from({ length: columns }).map((_, index) => (
              <TableCell key={index}>
                <Skeleton variant="text" width="80%" />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <TableCell key={colIndex}>
                  <Skeleton
                    variant="text"
                    width={colIndex === 0 ? '60%' : '80%'}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
